import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {TableLayoutSearchModel} from "../table-layout-search.model";
import {TableLayoutEntityModel} from "../table-layout-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-table-layout-search-page",
    templateUrl: "./table-layout-search-page.component.html",
    providers: [provideSearchModel(TableLayoutSearchModel), provideEntityModel(TableLayoutEntityModel)]
})
export class TableLayoutSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
